<template>
    <div class="assetSearch">
        <el-form :inline="true" v-model="formData" class="form-inline">
            <el-row>
                <el-form-item label="提现时间">
                    <el-date-picker
                        v-model="formData.range"
                        style="width: 100%;"
                        :unlink-panels="unlik"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="--"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-row>
            <el-row class="assetSearch-row">
                <el-col :span="18">
                <el-form-item label="提现进度">
                    <el-select v-model="formData.status" placeholder="请选择提现进度">
                        <el-option label="全部" value="-1"></el-option>                        
                        <el-option label="待审核" value="0"></el-option>
                        <el-option label="审核失败" value="4"></el-option>
                        <el-option label="待交发票" value="1"></el-option>
                        <el-option label="待收款" value="2"></el-option>
                        <el-option label="提现成功" value="3"></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6" class="assetSearch-btnBox">
                <el-form-item>
                    <el-button @click="onSubmit" class="btn assetSearch-search">查询</el-button>
                    <el-button @click="resetForm" class="btn assetSearch-reset">重置</el-button>
                </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                 unlik: true,
                formData: {
                    status: '',
                    range: [],
                }
            }
        },
        methods: {
            onSubmit() {
                // console.log(this.formInline.region);
                this.$emit('assetSearch',this.formData);
            },
            resetForm() {
                this.formData = {
                    status: '',
                    range: [],
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '../style/mixin';
.assetSearch{
    padding: 20px;
     border: 1px solid #eee;
    @include flex-row;
    justify-content: flex-start;
    margin-top: 10px;
}
.form-inline{
    width: 100%;
}
.assetSearch-row{
    // display: flex;
    width: 100%;
    // justify-content: space-around;
}
.assetSearch-btnBox{
    text-align: right;
}
.btn{
    width: 80px;
    height: 36px;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
}
.assetSearch-search{
    background-color: #2ecc72;
}
.assetSearch-reset{
    background-color: #cdcdcd;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetSearch.vue